import React, { useEffect, useState } from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  const reduce = useReducedMotion();
  useEffect(() => {
    const check = () => {
      const anchor = document.getElementById("hero-cta");
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener("scroll", check, {
      passive: true
    });
    window.addEventListener("resize", check);
    return () => {
      window.removeEventListener("scroll", check);
      window.removeEventListener("resize", check);
    };
  }, []);
  return <AnimatePresence data-id="element-2" data-mp="195wvbl25i5dn">
      {visible && <motion.div className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2 sm:pb-5" initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 24
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-3" data-mp="197rccoaaxdcg">
          <motion.a href={CHECKOUT_URL} className="mx-auto flex w-full max-w-md items-center justify-center gap-2 rounded-2xl bg-cta px-5 py-4 text-center text-[15px] font-extrabold uppercase tracking-wide text-white shadow-[0_6px_0_#11833B,0_12px_28px_rgba(9,26,51,0.35)] focus:outline-none focus-visible:ring-4 focus-visible:ring-cyan/50 sm:text-base" animate={reduce ? undefined : {
        x: [0, -7, 7, -6, 6, -3, 3, 0]
      }} transition={reduce ? undefined : {
        duration: 0.45,
        ease: "easeInOut",
        repeat: Infinity,
        repeatDelay: 1.6
      }} data-id="element-4" data-mp="2f3ixix4w9n9t">
            Get the Endo Blueprint™ — $27
            <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-5" data-mp="1nepi31mbge1a" />
          </motion.a>
        </motion.div>}
    </AnimatePresence>;
}